import './App.css';
import Navbar from './components/navbar/Navbar';
import Header from './components/header/Header';
import TodoList from './components/todolist/TodoList';
import Footer from './components/footer/Footer';
import { Provider } from 'react-redux';
import store from './redux/store';
import CompleteTodoList from './components/completeTodoList/CompleteTodoList';

function App() {
  return (
    <Provider store={store}>
      <div
        className="flex flex-col items-center bg-blue-100 h-screen px-6 font-sans overflow-y-auto"
      >
        {/* <!-- navbar --> */}
        <Navbar />
        <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white mt-20">
          {/* <!-- header --> */}
          <Header />
          <hr className="mt-4" />

          {/* <!-- todo list --> */}
          <TodoList />

          <hr className="mt-4" />

          {/* <!-- footer --> */}
          <Footer />
        </div>
        <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white mt-4">
          <CompleteTodoList />
        </div>

      </div>
    </Provider>
  );
}

export default App;
